<section>
    <ul class="mainUl">
        <li class="mainli" class="mb-4" *ngFor="let item of menu" (click)="setRoute(item)"
            [ngClass]="{'active': item.status}">
            <a>
                {{item.name}}
            </a>
        </li>
    </ul>
</section>
<div>

    <nav class="navbar navbar-dark">
        <div class="container-fluid">
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent"
                aria-expanded="false" aria-label="Toggle navigation">
                <span>
                    <img style="width: 40px" src="assets/images/icon-menu.png">
                </span>
            </button>
        </div>
    </nav>
    <div class="collapse" id="navbarToggleExternalContent">
        <div class=" p-4">
            <li class="mainli" class="mb-4" *ngFor="let item of menu" (click)="setRoute(item)"
                [ngClass]="{'active': item.status}">
                <a>
                    {{item.name}}
                </a>
            </li>
        </div>
    </div>
</div>